import React, { useState } from 'react';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import frLocale from 'date-fns/locale/fr';
import enLocale from 'date-fns/locale/en-US';
import deLocale from 'date-fns/locale/de';
import esLocale from 'date-fns/locale/es';
import DateFnsUtils from '@date-io/date-fns';
import TextField from '@material-ui/core/TextField';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import styles from './styles/styles.module.scss';

const TextFieldComponent = props => {
  return <TextField {...props} disabled />;
};

const greenTint = '#69A041';
const green = '#428A13';
const greenShade = '#32690F';

const palette = {
  primary: {
    light: greenTint,
    main: green,
    dark: greenShade
  }
};

const theme = createMuiTheme({
  palette
});

const DatePicker = props => {
  const [isOpen, toggleOpen] = useState(false);
  const KeyboardIcon = isOpen ? ExpandLess : ExpandMore;
  const iconStyles = isOpen ? styles.activeIcon : styles.icon;
  const rootStyles = isOpen ? styles.expandedRoot : styles.root;
  const localeMap = {
    'en-US': enLocale,
    'de-DE': deLocale,
    'fr-FR': frLocale,
    'es-ES': esLocale
  };

  return (
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[props.locale]}>
        <KeyboardDatePicker
          disableToolbar
          variant="inline"
          className={props.className}
          onClick={() => toggleOpen(true)}
          onClose={() => toggleOpen(false)}
          open={isOpen}
          classes={{ root: `${rootStyles} ${props.slim ? styles.slim : ''}` }}
          disableFuture={props.disableFuture}
          format={props.abbreviateMonth ? 'MMM dd, yyyy' : 'MMMM dd, yyyy'}
          locale="es-ES"
          margin="normal"
          id="date-picker-inline"
          value={props.date}
          onChange={props.onChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
            classes: { root: styles.icon },
            disableRipple: true
          }}
          InputProps={{
            disableUnderline: true,
            classes: { root: styles.textInput }
          }}
          PopoverProps={{
            classes: { root: styles.popoverRoot },
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left'
            },
            transformOrigin: {
              vertical: -16,
              horizontal: 14
            },
            getContentAnchorEl: null
          }}
          keyboardIcon={<KeyboardIcon className={iconStyles} />}
          TextFieldComponent={TextFieldComponent}
        />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
};

DatePicker.defaultProps = {
  onChange: () => {},
  maxDate: new Date(),
  locale: 'en-US',
  disableFuture: true,
  abbreviateMonth: false
};

export default DatePicker;
